import { DataTableColumnHeader } from "@/components/data-table/data-table-column-header";
import { CustomColumnDef } from "@/components/data-table/types/custom-column-def";
import { Badge, Button } from "@capacit-com/lara-law-shared-ui";
import ToneOfVoice from "@/models/tone-of-voice/toneOfVoice";
import { TrashIcon } from "lucide-react";

export const ToneOfVoiceColumns = (
  handleDeleteDialogOpen: (toneOfVoice: ToneOfVoice) => void,
  canDelete: boolean
): CustomColumnDef<ToneOfVoice>[] => [
  {
    accessorKey: "title",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Titel" />
    ),
    cell: ({ row }: { row: { original: ToneOfVoice } }) => {
      const toneOfVoice = row.original;
      return (
        <div className="truncate" title={toneOfVoice.title}>
          {toneOfVoice.title}
        </div>
      );
    },
    meta: {
      displayName: "Titel",
      dataType: "text",
    },
  },
  {
    accessorKey: "description",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Beskrivelse" />
    ),
    cell: ({ row }: { row: { original: ToneOfVoice } }) => {
      const toneOfVoice = row.original;
      return (
        <div className="truncate" title={toneOfVoice.description}>
          {toneOfVoice.description}
        </div>
      );
    },
    meta: {
      displayName: "Beskrivelse",
      dataType: "text",
      headerClassName: "w-full",
      cellClassName: "w-full max-w-0",
    },
  },
  {
    accessorKey: "isDefault",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Standard" />
    ),
    cell: ({ row }: { row: { original: ToneOfVoice } }) => {
      const toneOfVoice = row.original;
      return toneOfVoice.isDefault ? (
        <Badge variant="secondary">Standard</Badge>
      ) : null;
    },
    meta: {
      displayName: "Standard",
      dataType: "text",
      headerClassName: "w-px",
      cellClassName: "w-px",
    },
  },
  ...(canDelete
    ? [
        {
          accessorKey: "delete",
          header: ({ column }) => (
            <DataTableColumnHeader column={column} title="Handlinger" />
          ),
          cell: ({ row }: { row: { original: ToneOfVoice } }) => {
            const toneOfVoice = row.original;

            return (
              <Button
                variant="ghost"
                size="sm"
                aria-label={`Slet ${toneOfVoice.title}`}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  handleDeleteDialogOpen(toneOfVoice);
                }}
              >
                <TrashIcon className="size-4 text-destructive" />
              </Button>
            );
          },
          enableSorting: false,
          meta: {
            displayName: "Handlinger",
            headerClassName: "w-px",
            cellClassName: "w-px",
          },
        } as CustomColumnDef<ToneOfVoice>,
      ]
    : []),
];
